export type PartnerGender = 'MALE' | 'FEMALE' | 'OTHER';

const normalizeGenderValue = (value: string) =>
  value
    ?.toUpperCase()
    ?.normalize('NFD')
    ?.replace(/[\u0300-\u036f]/g, '')
    ?.trim() || '';

const MALE_VALUES = new Set([
  'HOMBRE',
  'MASCULINO',
  'M',
  'H',
  'VARON',
  'MALE',
  'MAN',
]);

const FEMALE_VALUES = new Set(['MUJER', 'FEMENINO', 'F', 'FEMALE', 'WOMAN']);

const OTHER_VALUES = new Set(['OTRO', 'OTHER', 'O', 'NO BINARIO', 'NOBINARIO', 'NB']);

const getPartnerGenderFromExcel = (value: string): PartnerGender | undefined => {
  const normalized = normalizeGenderValue(value);

  if (!normalized) {
    return undefined;
  }

  if (MALE_VALUES.has(normalized)) {
    return 'MALE';
  }

  if (FEMALE_VALUES.has(normalized)) {
    return 'FEMALE';
  }

  if (OTHER_VALUES.has(normalized)) {
    return 'OTHER';
  }

  return 'OTHER';
};

export default getPartnerGenderFromExcel;
